function openTab(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablink");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";

  updateDropdown(tabName);

  closeDropdown();
}

function openNestedTab(evt, tabName) {
  var i, nestedTabcontent, nestedTablinks;
  nestedTabcontent = document.getElementsByClassName("nested-tabcontent");
  for (i = 0; i < nestedTabcontent.length; i++) {
    nestedTabcontent[i].style.display = "none";
  }
  nestedTablinks = document.getElementsByClassName("nested-tablink");
  for (i = 0; i < nestedTablinks.length; i++) {
    nestedTablinks[i].className = nestedTablinks[i].className.replace(
      " active",
      ""
    );
  }
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}

function updateDropdown(tabName) {
  var dropdownContainer = document.querySelector(".dropdown-container");
  var dropdown = document.getElementById("dropdown-content");
  var dropdownButton = document.querySelector(".dropdown-button");
  var tablinks = document.querySelectorAll(".tablink-mobile");
  var currentTabText = document.querySelector(
    `.tablink[onclick*='${tabName}']`
  ).innerText;

  var isDropdownVisible =
    getComputedStyle(dropdownContainer).display !== "none";

  if (isDropdownVisible) {
    dropdownButton.querySelector("span").innerText = currentTabText;
  }

  tablinks.forEach((link) => {
    if (link.innerText === currentTabText && isDropdownVisible) {
      link.style.display = "none";
    } else {
      link.style.display = "block";
    }
  });
}

function toggleDropdown() {
  var dropdown = document.getElementById("dropdown-content");
  var dropdownButton = document.querySelector(".dropdown-button");

  dropdown.classList.toggle("show");

  dropdownButton.classList.toggle("open");
}

function closeDropdown() {
  var dropdown = document.getElementById("dropdown-content");
  var dropdownButton = document.querySelector(".dropdown-button");

  dropdown.classList.remove("show");

  dropdownButton.classList.remove("open");
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelector(".tablink").click();
  document.querySelector(".nested-tablink").click();

  document
    .querySelector(".dropdown-button")
    .addEventListener("click", toggleDropdown);

  window.addEventListener("click", function (event) {
    if (
      !event.target.matches(".dropdown-button") &&
      !event.target.closest(".dropdown-container")
    ) {
      closeDropdown();
    }
  });
});
